var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "ChannelForwardSetting" } },
    [
      _c("div", { staticClass: "departman-card" }, [
        _c("div", { staticClass: "mode-card" }, [
          _c(
            "div",
            { staticClass: "title" },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("message.departmentForwardEnable")) +
                  "\n                "
              ),
              _c("a-switch", {
                staticClass: "md-warning ml-3",
                attrs: {
                  "checked-children": "✔",
                  "un-checked-children": "✖",
                  checked: !!_vm.channel.forward.department,
                },
                on: { click: _vm.toggleDepartmentForwardingRule },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "subtitle" }, [
            _vm._v(_vm._s(_vm.$t("message.departmentForwardDesc"))),
          ]),
          _vm._v(" "),
          _vm.channel.forward.department
            ? _c(
                "div",
                [
                  _c(
                    "a-select",
                    {
                      staticStyle: { width: "100%", "margin-top": "10px" },
                      attrs: {
                        defaultValue: undefined,
                        notFoundContent: _vm.$t(
                          "search.integration.forwardLiveAgents"
                        ),
                        getPopupContainer: function (triggerNode) {
                          return triggerNode.parentNode
                        },
                        dropdownStyle: { maxHeight: "400px", overflow: "auto" },
                      },
                      on: { change: _vm.handleSelectChange },
                      model: {
                        value: _vm.channel.forward.department,
                        callback: function ($$v) {
                          _vm.$set(_vm.channel.forward, "department", $$v)
                        },
                        expression: "channel.forward.department",
                      },
                    },
                    [
                      _c(
                        "a-select-option",
                        { key: "null", attrs: { value: undefined } },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.$t("search.integration.forwardLiveAgents")
                              ) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.departments, function (department) {
                        return _c(
                          "a-select-option",
                          {
                            key: department._id,
                            attrs: { value: department._id },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.getDepartmentTitle(department)) +
                                "\n                    "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  !_vm.isSelectedDepartmentValid
                    ? _c("a-alert", {
                        staticClass: "mt-1",
                        attrs: {
                          description:
                            "Bu kanal yönlendirdiğiniz departmant geçerli bir departman değildir. Kanalınızı göremeyen bir departmana yönlendirme yapılıyor. Kanalın gizlilik ayarlarını kontrol ediniz.",
                          message: "Hatalı Departman Yönlendirme Seçimi",
                          showIcon: "",
                          type: "error",
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "mode-card-content" }, [
        _c(
          "div",
          { staticClass: "mode-card", staticStyle: { "max-height": "150px" } },
          [
            _c(
              "div",
              { staticClass: "title" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.liveFabListDescription")) +
                    "\n                "
                ),
                _c("a-switch", {
                  staticClass: "md-warning ml-3",
                  attrs: {
                    "checked-children": "✔",
                    "un-checked-children": "✖",
                  },
                  on: { change: _vm.handleLiveSupportModeChange },
                  model: {
                    value: _vm.liveMode,
                    callback: function ($$v) {
                      _vm.liveMode = $$v
                    },
                    expression: "liveMode",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "subtitle" }, [
              _vm._v(_vm._s(_vm.$t("message.AssignMessagesToAgents"))),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mode-card", staticStyle: { "max-height": "150px" } },
          [
            _c(
              "div",
              { staticClass: "title" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("chatbotv2.chatbot")) +
                    "\n                "
                ),
                _c("a-switch", {
                  staticClass: "md-warning ml-3",
                  attrs: {
                    "checked-children": "✔",
                    "un-checked-children": "✖",
                  },
                  on: { change: _vm.handleChatbotModeChange },
                  model: {
                    value: _vm.chatbotMode,
                    callback: function ($$v) {
                      _vm.chatbotMode = $$v
                    },
                    expression: "chatbotMode",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "subtitle" }, [
              _vm._v(_vm._s(_vm.$t("message.firstChatbotAndAssign"))),
            ]),
            _vm._v(" "),
            _vm.chatbotMode
              ? _c(
                  "div",
                  [
                    _c(
                      "a-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          notFoundContent: _vm.$t(
                            "search.integration.forwardLiveAgents"
                          ),
                          defaultValue: undefined,
                          getPopupContainer: function (triggerNode) {
                            return triggerNode.parentNode
                          },
                          dropdownStyle: {
                            maxHeight: "400px",
                            overflow: "auto",
                          },
                        },
                        on: { change: _vm.handleSelectChange },
                        model: {
                          value: _vm.channel.forward.story,
                          callback: function ($$v) {
                            _vm.$set(_vm.channel.forward, "story", $$v)
                          },
                          expression: "channel.forward.story",
                        },
                      },
                      [
                        _c(
                          "a-select-option",
                          { key: "null", attrs: { value: undefined } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t("search.integration.forwardLiveAgents")
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.stories, function (story) {
                          return _c(
                            "a-select-option",
                            { key: story._id, attrs: { value: story._id } },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(story.title) +
                                  "\n                    "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "mode-card" }, [
          _c(
            "div",
            { staticClass: "title" },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("report.hybrid")) +
                  "\n                "
              ),
              _c("a-switch", {
                staticClass: "md-warning ml-3",
                attrs: { "checked-children": "✔", "un-checked-children": "✖" },
                on: { change: _vm.handleHybridModeChange },
                model: {
                  value: _vm.hybridChatMode,
                  callback: function ($$v) {
                    _vm.hybridChatMode = $$v
                  },
                  expression: "hybridChatMode",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "subtitle" }, [
            _vm._v(_vm._s(_vm.$t("message.hybridAssign"))),
          ]),
          _vm._v(" "),
          _vm.channel.forward.mode === "hybrid"
            ? _c("div", { staticStyle: { "margin-top": "5px" } }, [
                _c(
                  "div",
                  [
                    _c("b", { staticStyle: { "font-size": "11px" } }, [
                      _vm._v(
                        "(" +
                          _vm._s(_vm.$t("message.checkDepartmentToAgent")) +
                          ")"
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          notFoundContent: _vm.$t(
                            "search.integration.forwardLiveAgents"
                          ),
                          defaultValue: undefined,
                          getPopupContainer: function (triggerNode) {
                            return triggerNode.parentNode
                          },
                          dropdownStyle: {
                            maxHeight: "400px",
                            overflow: "auto",
                          },
                        },
                        on: { change: _vm.handleSelectChange },
                        model: {
                          value: _vm.hybridDepartment,
                          callback: function ($$v) {
                            _vm.hybridDepartment = $$v
                          },
                          expression: "hybridDepartment",
                        },
                      },
                      [
                        _c(
                          "a-select-option",
                          { attrs: { selected: true, value: undefined } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t("search.integration.allDepartments")
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.departments, function (department) {
                          return _c(
                            "a-select-option",
                            {
                              key: department._id,
                              attrs: { value: department._id },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.getDepartmentTitle(department)) +
                                  "\n                        "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("b", { staticStyle: { "font-size": "11px" } }, [
                      _vm._v(
                        "(" + _vm._s(_vm.$t("message.ifAllOfflineStory")) + ")"
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          notFoundContent: _vm.$t(
                            "search.integration.forwardLiveAgents"
                          ),
                          defaultValue: undefined,
                          getPopupContainer: function (triggerNode) {
                            return triggerNode.parentNode
                          },
                          dropdownStyle: {
                            maxHeight: "400px",
                            overflow: "auto",
                          },
                        },
                        on: { change: _vm.handleSelectChange },
                        model: {
                          value: _vm.channel.forward.story,
                          callback: function ($$v) {
                            _vm.$set(_vm.channel.forward, "story", $$v)
                          },
                          expression: "channel.forward.story",
                        },
                      },
                      [
                        _c(
                          "a-select-option",
                          { key: "null", attrs: { value: undefined } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t("search.integration.forwardLiveAgents")
                                ) +
                                "\n                        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.stories, function (story) {
                          return _c(
                            "a-select-option",
                            { key: story._id, attrs: { value: story._id } },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(story.title) +
                                  "\n                        "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.groupChatbotView
        ? _c("div", { staticClass: "group-chatbot-card" }, [
            _c("div", { staticClass: "mode-card" }, [
              _c(
                "div",
                { staticClass: "title" },
                [
                  _vm._v(
                    "\n                Chatbot Grup Mesajlarına Cevap Versin\n                "
                  ),
                  _c("a-switch", {
                    staticClass: "md-warning ml-3",
                    attrs: {
                      "checked-children": "✔",
                      "un-checked-children": "✖",
                      checked: !!_vm.channel.forward.chatbotRespondToGroupChats,
                    },
                    on: { click: _vm.toggleChatbotRespondToGroupChats },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "subtitle" }, [
                _vm._v(
                  "\n                Chatbot'un grup mesajlarına cevap vermesini istiyorsanız bu seçeneği aktif hale getirin.\n            "
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.enabledZohoTransfer
        ? _c("ZohoForwardSettings", { attrs: { channel: _vm.channel } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }